import { LIGHT_BLUE, NEAR_WHITE } from "../../config/colors";
import styled, { css } from "styled-components";

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  text-align: center;
  color: ${NEAR_WHITE};
  padding-bottom: 1rem;
  cursor: pointer;
`;

export const PaginationItem = styled.div<{ active: boolean }>`
  font-size: 12px;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  outline: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  ${(props) =>
    props.active &&
    css`
      color: ${LIGHT_BLUE};
    `}
`;

export const ButtonsContainer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: end;
  width: 100%;
`;
